import { Nullable } from "@/types/common";
import { GenerationPageResponse, Image } from "@/types/thread";

export function getNextGenSlug(
  additionalGenerations: GenerationPageResponse["additionalGenerations"],
  createdAt: string
) {
  if (additionalGenerations.length === 0) return null;
  const sortedGens = [...additionalGenerations].sort((a, b) => {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  });
  const nextGen = sortedGens.find(
    (gen) => new Date(gen.createdAt).getTime() > new Date(createdAt).getTime()
  );
  return nextGen?.slug
    ? `${nextGen.slug}-${nextGen.id}`
    : `${sortedGens[0].slug}-${sortedGens[0].id}`;
}

export function getPrevGenSlug(
  additionalGenerations: GenerationPageResponse["additionalGenerations"],
  createdAt: string
) {
  if (additionalGenerations.length === 0) return null;
  const sortedGens = [...additionalGenerations].sort((a, b) => {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
  const prevGen = sortedGens.find(
    (gen) => new Date(gen.createdAt).getTime() < new Date(createdAt).getTime()
  );
  return prevGen?.slug
    ? `${prevGen.slug}-${prevGen.id}`
    : `${sortedGens[0].slug}-${sortedGens[0].id}`;
}

export function getHighlightedImage(
  highlightedId: Nullable<string>,
  images: Image[],
  isSubscribed: boolean
) {
  if (highlightedId) {
    if (!isSubscribed && images.some((i) => i.locked)) {
      const imageIndex = images.findIndex((image) => !image.locked);
      return imageIndex !== -1 ? imageIndex : 0;
    }
    const imageIndex = images.findIndex(
      (image) => image.id === Number(highlightedId)
    );
    return imageIndex !== -1 ? imageIndex : 0;
  }
  return 0;
}
